'use client';

import { InternalNetworkDangerContent } from '@terra/ui-design-system';
import { isInternalNetworkDiscoveryResetConflictError } from '../../../../clients/tester-client/internal-network-discovery-api';
import { useResetInternalNetworkDiscovery } from '../../../../hooks/api/useInternalNetworkDiscoveryStatus';
import { useDeleteInternalNetwork } from '../../../../hooks/api/useSurfaceSettings';
import { useReturnToWelcomeAfterTargetDelete } from '../../target-settings/useReturnToWelcomeAfterTargetDelete';

type InternalDangerSettingsPanelProps = {
  networkId: string;
  surfaceName: string;
  isDiscoveryActive: boolean;
};

export function InternalDangerSettingsPanel({
  networkId,
  surfaceName,
  isDiscoveryActive,
}: InternalDangerSettingsPanelProps) {
  const deleteNetwork = useDeleteInternalNetwork();
  const resetDiscoveryData = useResetInternalNetworkDiscovery(networkId);
  const returnToWelcome = useReturnToWelcomeAfterTargetDelete();

  return (
    <InternalNetworkDangerContent
      networkName={surfaceName}
      isDiscoveryActive={isDiscoveryActive}
      isResetting={resetDiscoveryData.isPending}
      isDeleting={deleteNetwork.isPending}
      onResetDiscoveryData={async () => {
        await resetDiscoveryData.mutateAsync();
      }}
      onDelete={async () => {
        await deleteNetwork.mutateAsync(networkId);
        returnToWelcome();
      }}
      isResetConflictError={isInternalNetworkDiscoveryResetConflictError}
    />
  );
}
